var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoStripeArrow = function SvgIcoStripeArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 34,
    fill: "none",
    viewBox: "0 0 18 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M16.42 15.349a2 2 0 0 0-.12-.155L4.74 1.658a2.1 2.1 0 0 0-3.194 2.728l10.783 12.626L1.433 29.77a2.1 2.1 0 1 0 3.194 2.727l12.08-14.143a2.1 2.1 0 0 0-.287-3.005",
    clipRule: "evenodd"
  })));
};
export default SvgIcoStripeArrow;